function paramsSerializer(params) {
  const result = [];

  Object.entries(params).forEach(([key, val]) => {
    if (Array.isArray(val)) {
      if (val.length) {
        val.forEach((item) => {
          result.push(`${key}=${item}`);
        });
      }
    } else if (val) {
      result.push(`${key}=${val}`);
    }
  });

  return result.join('&');
}

export default paramsSerializer;
